import { render, staticRenderFns } from "./normal.vue?vue&type=template&id=2c0a664e&"
import script from "./normal.vue?vue&type=script&lang=js&"
export * from "./normal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Media: require('/Users/rabbitfoot/Bitbucket/garden-eight-v3/nuxt/components/media/index.vue').default})
